"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadClientPreference = exports.getClientPreference = exports.isClientRoleFeatureAllowed = exports.setCurrentUserClientRoles = exports.getSelectedClientId = exports.setSelectedClientId = exports.getSelectedClientName = exports.getSelectedClientCompanyName = exports.setSelectedClientName = void 0;
var gqls_1 = require("./graphql/gqls");
var setSelectedClientName = function (clientName) {
    try {
        sessionStorage.setItem('selectedClientName', clientName);
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.setSelectedClientName = setSelectedClientName;
var getSelectedClientCompanyName = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var client;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (clientId === undefined) {
                    clientId = (0, exports.getSelectedClientId)();
                }
                if (clientId === 0) {
                    alert('Failed to get Client id');
                    return [2 /*return*/, ''];
                }
                if (sessionStorage.getItem('selectedClientCompanyName')) {
                    return [2 /*return*/, sessionStorage.getItem('selectedClientCompanyName')];
                }
                return [4 /*yield*/, (0, gqls_1.getClientPublicDetails)(clientId)];
            case 1:
                client = _a.sent();
                if (client) {
                    sessionStorage.setItem('selectedClientCompanyName', client.companyName);
                    return [2 /*return*/, client.companyName];
                }
                alert("Failed fetching client company name. Please contact support");
                return [2 /*return*/, ''];
        }
    });
}); };
exports.getSelectedClientCompanyName = getSelectedClientCompanyName;
var getSelectedClientName = function () {
    var selectedClientName = sessionStorage.getItem('selectedClientName');
    if (selectedClientName) {
        return selectedClientName;
    }
    console.error('No Selected Client Name');
    return '';
};
exports.getSelectedClientName = getSelectedClientName;
var setSelectedClientId = function (clientId) {
    try {
        sessionStorage.setItem('selectedClientId', clientId.toString());
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.setSelectedClientId = setSelectedClientId;
var getSelectedClientId = function () {
    var selectedClientId = sessionStorage.getItem('selectedClientId');
    if (selectedClientId) {
        return parseInt(selectedClientId);
    }
    console.error('No Selected Client Id');
    return 0;
};
exports.getSelectedClientId = getSelectedClientId;
var setCurrentUserClientRoles = function (privileges, role) {
    if (role.includes("RESOLVEX")) {
        sessionStorage.priv = 'adm';
        return;
    }
    if (privileges) {
        var priv = privileges.map(function (obj) {
            delete obj.__typename;
            return obj;
        });
        sessionStorage.setItem('priv', JSON.stringify(priv));
    }
};
exports.setCurrentUserClientRoles = setCurrentUserClientRoles;
var isClientRoleFeatureAllowed = function (feature, access) {
    if (sessionStorage.priv) {
        if (sessionStorage.priv === 'adm') {
            return true;
        }
        var regexPattern = new RegExp("\\{(?:[^{}]*\"feature\":\"".concat(feature, "\"[^{}]*)*\"").concat(access, "\""), 'g');
        var hasMatch = regexPattern.test(sessionStorage.priv);
        return hasMatch;
    }
    return false;
};
exports.isClientRoleFeatureAllowed = isClientRoleFeatureAllowed;
var DEFAULT_PREF = {
    state: "",
    isPrimaryTabsOnly: false,
    isSoslEnabled: false,
    lineCalledList: [],
    timeZone: '',
    timeCycle: '',
};
var CLIENT_PREF_STATUS = '';
var CLIENT_PREFERENCE = DEFAULT_PREF;
/**
 * loads pref in storage
 * use loadClientPreference to get new deets
 */
var getClientPreference = function () {
    if (CLIENT_PREFERENCE.timeZone !== '') {
        return CLIENT_PREFERENCE;
    }
    try {
        var f = sessionStorage.getItem("".concat((0, exports.getSelectedClientName)(), "_Pref")) || '';
        var pref = JSON.parse(f);
        if (typeof pref === 'object' && pref !== null) {
            return pref;
        }
        return DEFAULT_PREF;
    }
    catch (e) {
        console.error(e);
        return DEFAULT_PREF;
    }
};
exports.getClientPreference = getClientPreference;
var loadClientPreference = function (client_name) { return __awaiter(void 0, void 0, void 0, function () {
    var clientName, key, pref;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (CLIENT_PREF_STATUS === 'loading')
                    return [2 /*return*/];
                CLIENT_PREF_STATUS = 'loading';
                clientName = client_name || (0, exports.getSelectedClientName)();
                if (!clientName) {
                    console.warn('no client selected');
                    return [2 /*return*/, undefined];
                }
                key = "".concat(clientName, "_Pref");
                return [4 /*yield*/, (0, gqls_1.getClientPreferenceGql)({
                        clientName: clientName,
                        getCache: true,
                    })];
            case 1:
                pref = _a.sent();
                sessionStorage.setItem(key, JSON.stringify(pref));
                CLIENT_PREF_STATUS = '';
                CLIENT_PREFERENCE = pref || DEFAULT_PREF;
                return [2 /*return*/, pref];
        }
    });
}); };
exports.loadClientPreference = loadClientPreference;
//# sourceMappingURL=clientSession.js.map